import { DateTime } from "luxon";

export class Day {
    constructor(name: string, available: boolean, dayOfWeek: number) {
        this.name = name;
        this.isAvailable = available;
        this.dayOfWeek = dayOfWeek;
    }
    name: string;
    isAvailable: boolean;
    dayOfWeek: number;

    slots: TimeSlot[] = [];
}

export class TimeSlot {
    constructor(id: number, start: string, end: string, available: boolean) {
        this.id = id;
        this.startTime = start;
        this.endTime = end;
        this.isAvailable = available;

        // // Notes: assumption is 1.5 hour slots

        // const start = `${String(hour).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
        // this.endHour = minutes == 0 ? hour + 1 : hour + 2;
        // this.endMinutes = minutes == 0 ? 30 : 0;
        // const end = `${String(this.endHour).padStart(2, '0')}:${String(this.endMinutes).padStart(2, '0')}`;
        this.name = `${this.startTime}`;// - ${this.endTime}`;
    }
    id: number;
    name: string;
    startTime: string;
    endTime: string;
    isAvailable: boolean;
    isBooked = false;
    isLocked = false;
    interviewName = "";
    isApplicantUnselectable = false;

}

export class SelectedTimeSlot {
    constructor(day: Day, timeSlot?: TimeSlot | undefined) {
        this.day = day;
        this.timeSlot = timeSlot;
    }
    day: Day;
    timeSlot?: TimeSlot | undefined;
}

export class Change {
    date: DateTime;
    timeSlot: string;
    originalValue: boolean;
    newValue: boolean;
    constructor(date: DateTime, timeSlot: string, value: boolean, old: boolean) {
        this.date = date;
        this.timeSlot = timeSlot;
        this.newValue = value;
        this.originalValue = old;
    }
}